import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {getWMSContainers} from "../../../../../../../../../api/wms/wmsContainers/wmsContainers";
import {WmsContainerType} from "../../../../../../../../../utils/WMSContainerType";
import {WMSContext} from "../../../../../../../context/WMSContext";
import RightDrawer from "../../../../../../../../../components/WMS/Mobile/RightDrawer";
import CustomButton from "../../../../../../../../../components/CustomButton";
import {FormattedMessage} from "react-intl";
import {Card, CardContent, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {grey300} from "../../../../../../../../../assets/jss/main";
import BeatLoaderRegular from "../../../../../../../../../components/loaders/BeatLoaderRegular";

TipperManualSelectionDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleSelectedTipper: PropTypes.func.isRequired,
    currentShipment: PropTypes.object.isRequired,
    isCC: PropTypes.bool.isRequired,
    isCcInternalWMSShip: PropTypes.bool,
    loading: PropTypes.bool.isRequired,
    setLoading: PropTypes.func.isRequired
};

function TipperManualSelectionDrawer({open, handleClose, handleSelectedTipper, currentShipment, isCC, loading, setLoading, isCcInternalWMSShip = null}) {
    const {currentInventory, currentOrganization} = useContext(WMSContext)

    const [tipperList, setTipperList] = useState([])
    const [selectedTipper, setSelectedTipper] = useState()
    const [internalLoading, setInternalLoading] = useState(true)

    const handleChange = (event) => {
        setSelectedTipper(event.target.value)
    }

    useEffect(() => {
        if (currentInventory) {
            const typeParameter = (isCC && !isCcInternalWMSShip)
                ? `type[]=${WmsContainerType.CC}`
                : `type[]=${WmsContainerType.TIPPER}&type[]=${WmsContainerType.TROLLEY}`

            getWMSContainers(currentInventory.id, typeParameter).then(response => {
                let tippers = response

                if (currentOrganization.containerToShippingMethodMatch) {
                    tippers = tippers.filter((tipper) => tipper.shippingMethods?.some(sm => sm.id === currentShipment.shippingMethodId) || !tipper.shippingMethods?.length)
                }

                setTipperList(tippers)

                setInternalLoading(false)
            }).finally(() => {
                setInternalLoading(false)
            })
        }
    }, [currentInventory, currentOrganization]);
    return (
        <RightDrawer
            open={open}
            handleClose={handleClose}
            headerLeftContent={<span style={{marginLeft: "8px"}}><FormattedMessage id={"wms.triShipping.manualSelectionDrawer.title"}/></span>}
            footer={
                <CustomButton
                    fullWidth
                    disabled={!selectedTipper || loading}
                    loading={loading}
                    onClick={() => {
                        setLoading(true)
                        handleSelectedTipper(selectedTipper)
                    }}
                >
                     <FormattedMessage id={"wms.packing.manualDropZoneChoice.buttonLabel"}/>
                </CustomButton>
            }
        >

            {internalLoading && (
                <div style={{margin: "8px auto", width: "fit-content"}}>
                    <BeatLoaderRegular loading={true} size={15} />
                </div>
            )}

            <RadioGroup
                onChange={handleChange}
                value={selectedTipper}
            >
                {tipperList && tipperList.length > 0 && tipperList.map((tipper) => (
                    <Card>
                        <CardContent style={{padding: 0}}>
                            <FormControlLabel
                                value={tipper.codebar}
                                sx={{
                                    display: "flex",
                                    flexDirection: "row-reverse",
                                    justifyContent: "space-between",
                                    margin: 0,
                                    padding: "16px",
                                    ':hover': {
                                        backgroundColor: grey300,
                                    },
                                }}
                                control={<Radio/>}
                                label={tipper.name}
                            />
                        </CardContent>
                    </Card>
                ))}
            </RadioGroup>
        </RightDrawer>
    );
}

export default TipperManualSelectionDrawer;